import { mainSiteUrl } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="bg-background-100 rounded-3xl p-8 md:p-12 border border-background-200/70">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Ready to Explore the Latest VigorBuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-base md:text-lg mb-8 max-w-xl mx-auto">
            Access updated buying guides, product comparisons, and all the resources you need to shop smarter.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer"
            >
              Explore Now
              <i className="ri-arrow-right-line"></i>
            </a>
            <Link
              to="/guide/vigorbuy-spreadsheet-complete-guide"
              className="w-full sm:w-auto px-8 py-3.5 text-base font-medium text-foreground-700 border border-background-300 rounded-full hover:border-foreground-300 hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer"
            >
              Read Our Guide
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}